export default {
  name: "Trade Journal Tracker",
  technologies: "Python, Flask, JavaScript, React, PostgreSQL, Google Firebase",
  bullets: [
    "Developed a Flask app that imports user stock trades, stores them in PostgreSQL, calculates performance metrics, fetches market data via JavaScript API, and generates an analysis dashboard.",
  ],
};
